import Node from './node';

export default class AutoCreateLogic extends Node {
  clone() {
    return new AutoCreateLogic(this.text, this.attributes, this.children.map((c) => c.clone()), this.owner);
  }
}
